import { h, Component } from 'preact';
import Store from 'store/store';
import 'store/bolt/home';
import 'store/bolt/password';

import Button from 'components/bolt/button/button';
import ArrowDown from 'components/bolt/icons/arrowDown';
import Socials from 'components/bolt/socials/socials';
import SectionLoader from 'components/bolt/sectionLoader/sectionLoader';
import MovieDetails from 'components/bolt/movieDetails/movieDetails';
import Password from 'components/bolt/password/password';

import { scale } from 'utils/math';
import { cssString } from 'utils/cssString';
import { smoothScrollTo } from 'utils/smoothScroll';
import { joinClasses, accessNested } from 'utils/utils';
import { shouldShowShowtimes, getHeaderHeight } from 'utils/bolt';
import { isScrolledIntoView, isSectionUnderHeader } from 'utils/visibilityChecks';
import { sections } from 'pages/bolt_pages';

import s from 'components/bolt/home/home.sss';

export default class Home extends Component {

	constructor(props) {
		super(props);
		this.onScroll = this.onScroll.bind(this);
		this.showShowtimes = this.showShowtimes.bind(this);
		this.scrollToNext = this.scrollToNext.bind(this);
		this.openSynopsis = this.openSynopsis.bind(this);
	}

	componentWillMount() {
		this.isCalendarRemindMode = !shouldShowShowtimes();
	}

	componentDidMount() {
		window.addEventListener('scroll', this.onScroll, true);
		// Trigger an initial active percentage refresh
		Store.emit('UPDATE_HOME_ACTIVE_PERCENTAGE');

		this.resizeObserver = new ResizeObserver(entries => {
			if (entries[0]?.contentRect?.height) {
				Store.emit('UPDATE_SCROLL_CONTAINER_HEIGHT', entries[0]?.contentRect?.height >= (window.innerHeight - 64));
			}
		});
		if (this.innerContainer) {
			this.resizeObserver.observe(this.innerContainer);
		}
	}
	componentWillUnmount() {
		window.removeEventListener('scroll', this.onScroll, true);

		if (this.resizeObserver && this.innerContainer) {
			this.resizeObserver.unobserve(this.innerContainer);
		}
	}

	getVisibleSections() {
		const hiddenSections = this.props.store?.hiddenSections || {};
		return sections.filter(s => !hiddenSections[s.id]);
	}

	onScroll() {
		let store = Store.get();
		// TODO: generic modalOpen
		if (store.ignoreScroll) {
			return;
		}
		const showtimesOverlayOpen = store.header?.showtimesOverlay;
		const homeEntOverlayOpen = store.header?.homeEntOverlay;
		const pressKitOverlayOpen = store.header?.pressKitOverlay;
		const videoOverlayOpen = store.header?.videoOverlayOpen;
		if (showtimesOverlayOpen || homeEntOverlayOpen || pressKitOverlayOpen || videoOverlayOpen) {
			return;
		}

		let activePage = store.activePage;
		if (![this.props.id, ...sections.map(s => s.id)].includes(activePage)) {
			return;
		}
		try {
			let sectionVisible = ['boltHome', ...sections.map(s => s.id)].find(id => (
				isScrolledIntoView(this.base.querySelector(`[data-section="${id}"]`))
			));
			let sectionUnderHeader = ['boltHome', ...sections.map(s => s.id)].find(id => (
				isSectionUnderHeader(this.base.querySelector(`[data-section="${id}"]`))
			));

			if (sectionVisible && sectionVisible !== activePage) {
				Store.emit('SET_ACTIVE_PAGE', sectionVisible);
			}
			if (sectionUnderHeader) {
				Store.emit('SET_SECTION_UNDER_HEADER', sectionUnderHeader);
			}
		} catch (e) {}
	}

	showShowtimes() {
		Store.emit('SHOWTIMES_SHOW');
	}

	openSynopsis() {
		Store.emit('CLOSE_ALL_OVERLAYS', { animate: true });
		// TODO: not hardcoded boltSynopsis
		// Store.emit('CHANGE_ACTIVE_SECTION', 'boltSynopsis');
	}

	scrollToNext(e, time, force) {
		let scrollContainer = document.getElementById('mainScroll');
		let scrollTo = document.querySelector('.' + s.container).nextElementSibling;
		const isDesktop = accessNested(this.props, 'store.client.isDesktopSize', false);
		const hasSonyHeader = accessNested(this.props, 'store.appData.options.sonyFeatures.sonyHeader', false);
		const scrollOffset = isDesktop ? (hasSonyHeader ? 34 : 0) : (hasSonyHeader ? 58 : getHeaderHeight());

		smoothScrollTo(scrollContainer, scrollTo, time || 300, { offset: scrollOffset, force });
	}

	getBottomGap() {
		const { store } = this.props;

		const showtimesShowing = store.showtimes?.show;
		const homeEntShowing = store.homeEnt?.show;
		if (showtimesShowing || homeEntShowing) {
			return 0;
		}

		const isMobile = accessNested(store, 'client.deviceSize', 'mobile') === 'mobile';
		return (isMobile ? 32 : 40) + (store.footer.coveredScreenSize || 0);
	}

	determineHomeHeight() {
		if (typeof window === 'undefined') {
			return;
		}

		const { store } = this.props;
		const cookies = store.cookies || {};
		const externalCookieBanner = store.externalCookieBanner || {};
		// const isMobile = accessNested(store, 'client.deviceSize', 'mobile') === 'mobile';

		let maxHeight = window.innerHeight - this.getBottomGap();
		let marginTop = 0;

		if (cookies.cookieBannerOpen || externalCookieBanner.bannerOpen) {
			maxHeight -= cookies.height || 0;
			// if (!isMobile) {
			// 	maxHeight -= externalCookieBanner.height || 0;
			// 	marginTop = externalCookieBanner.height || 0;
			// }
		}

		return { maxHeight: maxHeight ? maxHeight + 'px' : '', marginTop: marginTop + 'px' };
	}

	getCopyFindCinemasOrRemind() {
		const findCinemas = accessNested(this.props, 'store.appData.copy.baseCopy.$FIND_CINEMAS', 'Find Cinemas');
		const remindMe = accessNested(this.props, 'store.appData.copy.baseCopy.$REMIND_ME', 'Save to Calendar');
		return this.isCalendarRemindMode ? remindMe : findCinemas;
	}

	triggerFindCinemasOrRemind() {
		this.isCalendarRemindMode ? Store.emit('SHOW_CAL_REMIND') : Store.emit('SHOWTIMES_SHOW');
	}

	renderExtraStuff() {
		return;
	}

	renderExtraTopSection() {
		return;
	}

	renderScrollArrow(copy, stickyFooter, isMobile, externalBannerOpen, hasMiniGallery, hideShadow) {
		return (
			<Button
				class={joinClasses(s.arrowBtn, stickyFooter && s.stickyFooter, (isMobile && externalBannerOpen) && s.hide, hasMiniGallery && s.hasMiniGallery)}
				trigger={this.scrollToNext}
				style={{ marginBottom: this.getBottomGap() + 'px' }}
				key="arrow"
				ariaLabel={copy.accessibilityCopy.$SCROLL_ARROW_ARIA}
			>
				<ArrowDown class={joinClasses(s.arrowDown, hideShadow && s.hideShadow)} aria-hidden />
			</Button>
		);
	}

	renderHomeSection(bgRender) {
		let props = this.props;
		// TODO: alow the homepage to have a different ID (loop through pages and check for page === home + base & everything)
		let boltHome = accessNested(props, 'store.appData.pages.boltHome');
		if (!boltHome) {
			return;
		}
		let store = props.store;
		let client = store.client;
		let appData = store.appData;
		let copy = appData.copy;
		let fontStyles = accessNested(appData, 'styling.fontVariables') || {};
		let homeData = accessNested(appData, 'pages.boltHome.data') || {};

		const activeSection = accessNested(store, 'header.activeSection');
		const homeActivePercentage = accessNested(store, 'homeActivePercentage', 1);
		const homeScrolledALittleBit = homeActivePercentage <= .8;
		const homeActive = !activeSection || activeSection === 'boltHome' || homeActivePercentage > .3;

		const stickyFooter = (accessNested(appData, 'footer.defaultFooter.position') || 'fixed') === 'fixed';

		let showtimesShowing = accessNested(store, 'showtimes.show');
		const homeEntShowing = accessNested(store, 'homeEnt.show');

		let sidePanelShowing = showtimesShowing || accessNested(store, 'homeEnt.show');
		let animateSidePanel = accessNested(store, 'showtimes.animate') || accessNested(store, 'homeEnt.animate');

		const externalBannerOpen = accessNested(store, 'externalCookieBanner.bannerOpen');
		const cookieHeight = (externalBannerOpen ? accessNested(store, 'externalCookieBanner.height') : accessNested(store, 'cookies.height')) || 0;
		const cookieBannerOpen = externalBannerOpen || accessNested(store, 'cookies.cookieBannerOpen');
		const isMobile = !client.isDesktopSize;

		const shouldShowSocials = (isMobile && homeData.socialIconsMobile) || (!isMobile && !stickyFooter);
		const hasMiniGallery = accessNested(appData, 'options.paramountFeatures.toutCarousel.contentCarousel', false);
		const scrollFade = scale(homeActivePercentage, .8, .3, 0, 1, true);

		const blackColor = accessNested(this.props, 'appData.styling.variables.black', '');
		const hideShadow = accessNested(this.props, 'appData.styling.variables.homeScrollArrow', '') === blackColor;

		const scrollable = this.getVisibleSections().length > 0;

		// Until we update preact, if we use custom properties we have to stringify "style"
		const containerStyle = {
			...this.determineHomeHeight(),
			'--scroll-fade': scrollFade,
		};

		return (
			<div
				class={joinClasses({
					s, container: true,
					sidePanelShowing,
					homeScrolledALittleBit,
					homeInactive: !homeActive,
					stickyFooter,
					animateSidePanel
				})}
				style={cssString(containerStyle)}
				data-section="boltHome"
				key="home"
			>
				{bgRender}
				{scrollable && <div class={s.scrollFade} />}
				<MovieDetails
					type="home"
					visible={homeActivePercentage >= 0.8 && !showtimesShowing && !homeEntShowing}
					hide={homeActivePercentage < 0.8 && !showtimesShowing && !homeEntShowing}
					tt={homeData.tt}
					buttons={[homeData.button1, homeData.button2, homeData.button3]}
					copy={copy}
					appData={appData}
					cookieHeight={cookieHeight}
					cookieBannerOpen={cookieBannerOpen}
					buttonLayout={homeData.btnLayout}
					client={this.props.client}
				/>
				{scrollable && this.renderScrollArrow(copy, stickyFooter, isMobile, externalBannerOpen, hasMiniGallery, hideShadow)}
				<Button
					class={joinClasses(s.filmDetails, fontStyles.showtimesOnesheetCTA)}
					trigger={this.openSynopsis}
					key="synopsis"
				>
					{copy.baseCopy.$FILM_DETAILS}
				</Button>
				{this.renderExtraStuff()}
				{shouldShowSocials && (
					<Socials
						class={joinClasses(s.socials, stickyFooter && s.socialsStickyFooter, hasMiniGallery && s.hasMiniGallery, hideShadow && s.hideShadow)}
						socials={accessNested(appData, 'header.powsterHeader.follow')}
						key="socials"
					/>
				)}
			</div>
		);
	}

	render(props) {
		const {
			// data,
			store = {},
			bgRender
		} = props;
		const {
			appData,
			client,
			unlockedSections
		} = store;

		let boltHome = accessNested(store, 'appData.pages.boltHome');
		const sectionFullPage = this.getVisibleSections().length === 1 && !boltHome;

		return (
			<div class={s.wrapper}>
				{this.renderHomeSection(bgRender)}
				<div
					ref={ref => this.innerContainer = ref}
					class={joinClasses(sectionFullPage && s.fullPage, s.innerContainer)}
					style={`--home-bottom-gap: ${this.getBottomGap()}px;`}
					key="sections"
				>
					{this.renderExtraTopSection()}
					{sections.map((section) => {
						const sectionProps = {
							store,
							appData,
							client,
							id: section.id,
							getter: section.getter,
							// activeSection,
							[section.component]: store[section.component],
							toggleOneSheet: this.toggleOneSheet,
							isSection: true,
							isLoneSection: sections.length === 1 && boltHome,
							sectionFullPage: sectionFullPage
						};

						const isPasswordProtected = appData.pages[section.id]?.data?.passwordGatewayPageId;
						const sectionPath = appData.pages[section.id].path;
						if (isPasswordProtected && (!unlockedSections || unlockedSections.indexOf(section.id) === -1)) {
							return (
								<Password
									appData={appData}
									id={isPasswordProtected}
									isSection
									sectionId={section.id}
									sectionPath={sectionPath}
								/>
							);
						}

						return !section.isPreloaded
							? <SectionLoader {...sectionProps} key={section.id} />
							: <section.component {...sectionProps} />;
					})}

				</div>
			</div>
		);
	}
}
